import styled from 'styled-components';

export const Container = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;

  text-align: center;

  font-size: 2.2rem;

  width: 100%;
  height: 5.8rem;
  padding: 2rem;

  background: linear-gradient(107deg, #ffd503 0%, #ffdf22 100%);
  border-radius: 5rem;

  transition: 180ms ease-in;

  &:hover {
    opacity: 0.85;
  }
`;

export const ButtonText = styled.p`
  font-weight: bold;
  font-size: 2.4rem;
  color: #000000;
`;
